import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteRowItem($companyId: ID!, $id: ID!) {
    deleteRowItem(companyId: $companyId, id: $id) {
       rowItem {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
